import { Component, OnInit, Input } from '@angular/core';
@Component({
  selector: 'app-general-settings-item',
  templateUrl: './general-settings-item.component.html',
  styleUrls: ['./general-settings-item.component.css']
})
export class GeneralSettingsItemComponent implements OnInit {

  @Input() icon: string;
  @Input() title: string;
  @Input() imgSrc: string;
  @Input() userChecks: boolean;
  @Input() isNew: boolean;
  @Input() newUntil: string;
  @Input() darkBg: boolean;

  @Input() darkBgMode: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  isNewBadgeVisible(): boolean {
    if (!this.isNew) {
      return false;
    }

    if (!this.newUntil) {
      return true;
    }

    const currentDate = new Date();
    const untilDate = new Date(this.newUntil);
    return currentDate <= untilDate;
  }


}
